import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { VictoryChartPoint } from '@oai-frontend-monorepo/types';
import { unescape } from 'querystring';

interface ChartCursor {
  x?: number;
  xDateString?: string;
  y?: number;
  points?: Array<
    VictoryChartPoint<{
      moveAmount?: number;
      movePercent?: number;
    }>
  >;
  futureScrub?: boolean;
}

interface ChartStore {
  chartCursor?: ChartCursor;
  setChartCursor: (cursor?: ChartCursor) => void;
  range: number;
  setRange: (range: number) => void;
  // focusPosition?: boolean;
  // setFocusPosition: (focusPosition: boolean) => void;
  mode: 'line' | 'candlestick';
  setMode: (mode: 'line' | 'candlestick') => void;
  whatIfTargetSet?: boolean;
  setWhatIfTargetSet: (whatIfTargetSet: boolean) => void;
  whatIfPrice?: number;
  setWhatIfPrice: (whatIfPrice?: number) => void;
  overrideWhatIfIv?: number;
  setOverrideWhatIfIv: (overrideWhatIfIv?: number) => void;
  entryDateOverride?: string;
  setEntryDateOverride?: (entryDateOverride?: string) => void;
}

export const useChartStore = create<ChartStore>()(
  devtools((set) => ({
    chartCursor: undefined,
    setChartCursor: (chartCursor) => {
      return set({ chartCursor });
    },
    range: 1,
    setRange: (range) => {
      return set({ range });
    },
    // focusPosition: false,
    // setFocusPosition: (focusPosition) => {
    //   return set({ focusPosition });
    // },
    mode: 'line',
    setMode: (mode) => {
      return set({ mode });
    },
    whatIfTargetSet: false,
    setWhatIfTargetSet: (whatIfTargetSet) => {
      return set({ whatIfTargetSet });
    },
    whatIfPrice: undefined,
    setWhatIfPrice: (whatIfPrice) => {
      return set({ whatIfPrice });
    },
    overrideWhatIfIv: undefined,
    setOverrideWhatIfIv: (overrideWhatIfIv) => {
      return set({ overrideWhatIfIv });
    },
    // 2025 05 10 at 1pm est but in iso
    entryDateOverride: undefined,
    setEntryDateOverride: (entryDateOverride) => {
      return set({ entryDateOverride });
    },
  }))
);
